const MIN_NON_EMPTY_LENGTH = 1;
export function isNonEmptyString(value?: string): value is string {
  return typeof value === 'string' && value.trim().length >= MIN_NON_EMPTY_LENGTH;
}

/** Email addresses are stored lowercase; normalize user input before it reaches the backend. */
export function normalizeEmail(value: string): string {
  return value.toLowerCase();
}
